import { Menu } from "semantic-ui-react";
import React from "react";
import { NavLink, useRouteMatch, useParams } from "react-router-dom";
import { useSettingValue } from "../../utils/Hooks";
import { useCanView } from "employee_tasks/components/utils";

export const EmployeeDetailTabs = () => {
  let { url } = useRouteMatch();
  const isEmployeePositionTasksEnabled = useSettingValue(
    "T012_EMPLOYEE_POSITION_TASKS_ENABLED",
  );

  const { employee_id: employeeId } = useParams();
  const canView = useCanView(Number(employeeId));

  return (
    <Menu secondary pointing stackable>
      <Menu.Item as={NavLink} to={`${url}/gestores`}>
        Gestores
      </Menu.Item>
      <Menu.Item as={NavLink} to={`${url}/cargos`}>
        Cargos
      </Menu.Item>
      <Menu.Item as={NavLink} to={`${url}/areas`}>
        Áreas
      </Menu.Item>
      <Menu.Item as={NavLink} to={`${url}/historico`}>
        Empresa
      </Menu.Item>
      {isEmployeePositionTasksEnabled && canView && (
        <Menu.Item as={NavLink} to={`${url}/tarefas_funcao`}>
          Tarefas da Função
        </Menu.Item>
      )}
    </Menu>
  );
};
